import { render, staticRenderFns } from "./ToggleOpenShift.vue?vue&type=template&id=18c1d193&"
import script from "./ToggleOpenShift.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ToggleOpenShift.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports